export default __webpack_public_path__ + "bb51b2517c61ab64f164be8e1d84c5bd.png";